import pick from 'lodash/pick'
import { useCallback } from 'react'

import { useAppSelector } from 'src/redux/hooks'
import { SubProduct, subProductsWithoutTargetPeriodInformations } from 'src/utils/product'
import { ComponentCode, ComponentsSettings } from 'src/utils/settings'
import useProductPage from './useProductPage'

const useGetDashboardPayload = () => {
  const { dashboardKey, code, program, product } = useProductPage()
  const settings = useAppSelector(s => s.componentsSettings.settings)

  const filterBarSettings = settings[dashboardKey]?.[ComponentCode.FilterBar]

  /**
   * Payload for saveNewDashboard/saveDashboard
   * @param label string
   */
  const handleGetSaveDashboardPayloadData = useCallback(
    (label: string) => {
      const comparisonDisabled = filterBarSettings?.timePeriod?.comparisonDisabled
      let target_period_informations: object = {
        period: filterBarSettings?.timePeriod?.selectedRange,
        frequency: filterBarSettings?.timePeriod.frequency || filterBarSettings?.timePeriod.view,
        custom_period: {
          start_date: filterBarSettings?.timePeriod.startDate,
          end_date: filterBarSettings?.timePeriod.endDate,
        },
        comparisonDisabled,
        comparison: filterBarSettings?.timePeriod?.comparison,
        enableCompare: filterBarSettings?.timePeriod?.enableCompare,
      }

      const settingsToSave = pick(settings, [dashboardKey])

      const components_settings = {
        [code]: settingsToSave[dashboardKey],
      }

      const payload: {
        product: string
        sub_product: string
        components_settings: Pick<ComponentsSettings, string>
        label: string
        program_id?: string | number
      } = {
        product,
        sub_product: code,
        components_settings,
        label,
        program_id: program,
      }

      if (program) {
        payload.program_id = program
      }

      if (!subProductsWithoutTargetPeriodInformations.includes(code as SubProduct)) {
        if (!comparisonDisabled) {
          target_period_informations = {
            ...target_period_informations,
            compare_to: filterBarSettings?.timePeriod?.selectedRangeCompare,
            custom_period: {
              ...target_period_informations['custom_period'],
              previous_start_date: filterBarSettings?.timePeriod.startDateCompare,
              previous_end_date: filterBarSettings?.timePeriod.endDateCompare,
            },
          }
        }
        payload['target_period_informations'] = target_period_informations
      }

      return { saved_dashboard: payload }
    },
    [filterBarSettings, code, product, settings, program],
  )

  return { handleGetSaveDashboardPayloadData }
}

export default useGetDashboardPayload
